// eslint-disable-next-line import/prefer-default-export
export const RESET_STATE = 'RESET_STATE';
export const RESET_NOT_PERSISTED = 'RESET_NOT_PERSISTED';



// WEBPACK FOOTER //
// ./src/store/mutation-type.js